import React from "react";
import styles from "./UiTypograhy.module.scss";
import clsx from "clsx";
export const Typograhy = ({ className, variant, label }) => {
  return (
    <div
      className={clsx(
        className,
        styles.wrapperTypograhy,
        styles[`wrapperTypograhy${variant}`]
      )}
    >
      {label}
    </div>
  );
};
